import React from 'react';
import {styles} from './styles.web';
import {AvatarProps} from './Avatar.types.web';
import {
  getAvatarGeneralStyles,
  getAvatarTextStyles,
  avatarIndicatorSizeMap,
  avatarButtonIconSizeMap,
  avatarContainerSizeMap,
  getInitials,
} from './Avatar.config.web';
import {useTheme} from '../../../../utils/theming/themeProvider';
import {IndicatorSize} from '../../Indicator/Indicator/indicator_types.web';

import {Size} from '../../Buttons/ButtonIcon/ButtonIcon.types.web';
import Indicator from '../../Indicator/Indicator/index.web';
import ButtonIcon from '../../Buttons/ButtonIcon/ButtonIcon.web';

const Avatar = (props: React.PropsWithChildren<AvatarProps>) => {
  const {
    id,
    className,
    type,
    image,
    text,
    size = '2xl',
    color,
    showIndicator,
    indicator,
    showButtonIcon,
    buttonIcon,
    containerStyle,
  } = props;

  // Avatar Styles
  const {colors, fontStyles} = useTheme();

  const avatarStyles = getAvatarGeneralStyles(
    colors,
    size,
    color || 'purple',
    type,
    image,
  );
  const textStyle = getAvatarTextStyles(fontStyles, colors, size);
  const containerStyles = styles();

  return (
    <div
      id={id}
      className={className}
      style={{
        position: 'relative',
        minWidth: avatarContainerSizeMap[size],
        height: avatarContainerSizeMap[size],
      }}>
      <div
        //@ts-ignore
        style={{
          ...containerStyles?.avatarCircle,
          ...avatarStyles,
          ...containerStyle,
          backgroundImage:
            image?.length && type === 'image' ? image : undefined,
        }}>
        {image?.length && type === 'image' ? (
          <img
            src={image}
            style={{
              objectFit: 'contain' as 'contain',
              width: '100%',
              height: '100%',
              borderRadius: avatarStyles.borderRadius,
            }}
          />
        ) : null}
        {showIndicator ? (
          <Indicator
            id={indicator?.id}
            className={indicator?.className}
            size={avatarIndicatorSizeMap[size] as IndicatorSize}
            color={indicator?.color || 'red'}
            type={indicator?.type || 'status'}
            quantity={indicator?.quantity || 0}
            containerStyle={{
              position: 'absolute',
              right: 0,
              top: 0,
            }}
          />
        ) : null}

        {text?.length && type === 'initials' ? (
          <p style={{...textStyle}}>{getInitials(text)}</p>
        ) : null}
      </div>
      {showButtonIcon && buttonIcon ? (
        <ButtonIcon
          {...buttonIcon}
          size={avatarButtonIconSizeMap[size] as Size}
          color={buttonIcon?.color || 'purple'}
          state={buttonIcon?.state || 'enable'}
          style={'round'}
          showStroke={true}
          containerStyle={{
            position: 'absolute',
            right: 0,
            bottom: 0,
          }}
        />
      ) : null}
    </div>
  );
};

export default Avatar;
